import type { InternalAxiosRequestConfig } from 'axios';
import { tokenService } from '@/services/token.service';

export const getHeaders = (token?: string): Record<string, string> => {
  const tokenToUse = token ?? tokenService.getToken();
  return {
    'X-App-Token': tokenToUse || '',
  };
};

/**
 * Bearer Token Interceptor for Axios
 * Automatically adds the authorization token to all requests
 */
export const useBearerTokenInterceptor = () => {
  return (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = tokenService.getToken();

    if (token) {
      config.headers['X-App-Token'] = `${token}`;
    }

    return config;
  };
};
